import { updateView, viewParams } from './update-view.js'

export function showTableChartsOfAccounts (chartOfAccountResponse) {
  console.log('showTableChartsOfAccounts', chartOfAccountResponse)

  viewParams.chartOfAccountResponse = chartOfAccountResponse

  const gridApi = updateView()

  return gridApi
}
